import React, { ReactElement } from 'react';
import { Grid } from 'semantic-ui-react';

// Styles
import './styles.scss';

interface Props {
    title?: string | React.ReactElement;
    /**
     * children should be an array of semantic UI Buttons with the following props
     * icon
     * circular
     * compact
     */
    children: React.ReactElement | React.ReactElement[];
}

/**
 * An action bar to be used inside semantic UI Card.Description
 */
const CardActionsBar = ({ title, children }: Props): React.ReactElement => (
    <div className="card-actions-bar">
        <Grid>
            <Grid.Column width={8}>{title}</Grid.Column>
            <Grid.Column width={8} textAlign="right">
                <div className="card-actions">{children}</div>
            </Grid.Column>
        </Grid>
    </div>
);

export default CardActionsBar;
